/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {BS2} from "../../../BS2";
import {BS2Symbol} from "../../../reels/BS2Symbol";
import {BS2Statics} from "../../../config/BS2Statics";
import {ScatterSymbol} from "../../../reels/ScatterSymbol";
import {GSAPUtils} from "../../../utils/GSAPUtils";
import {StateMatrixCoordinate} from "../../../utils/StateMatrix";
import {CollectScattersPresentationAvalanche} from "./CollectScattersPresentationAvalanche";
import {SplitLine} from "../../../view/parts/SplitLine";
import {PopAndMoveData, ScatterData, XSplitDirection} from "../../../server/BS2Data";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


export class SuperFreespinScatters implements SimplePresentation {
    name:string = "SuperFreespinScatters";
    private fsReTriggerPositions:StateMatrixCoordinate[];
    constructor() {
    }

    shouldRun():boolean {
        this.fsReTriggerPositions = BS2.model.visibleReelMatrix.getAllCoordinatesForValue(BS2Statics.SYMBOLS.S);
        return BS2.model.isSuperFreespin() &&   this.fsReTriggerPositions.length > 0;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => {
                controller.finish();
            }});
        tl.add(() => controller.setSkipCallback());

        const reTriggerSqueeze = [];
        for (let pos of this.fsReTriggerPositions){
            const squeezeTl = gsap.timeline();
            const ease:string = "slow(0.5, 0.7, false)";
            const popAndMoveData:PopAndMoveData = CollectScattersPresentationAvalanche.popScatterAndMove(pos, ease);
            if(BS2.apiPlugin.settings.get(APISetting.FAST_SPIN)){
                popAndMoveData.moveAnimation.timeScale(2);
            }
            squeezeTl.add(this.getReTriggerSymbolAnimation(pos,popAndMoveData));
            squeezeTl.add(()=>{
                BS2.keypadPlugin.setZeroBetSpinCounter(BS2.model.data.freespinsLeft);
                BS2.reelView.freespinCounter.showCount(BS2.model.data.freespinsLeft);
            }, "<0.70");
            reTriggerSqueeze.push(squeezeTl);
        }


        tl.add(GSAPUtils.createTimelineFromArray(reTriggerSqueeze, "<0.5"));
        tl.to(this, {duration:0.01});

    }

    public getReTriggerSymbolAnimation(scatterPos:StateMatrixCoordinate, popAndMoveData:PopAndMoveData):gsap.core.Timeline {
        const tl = gsap.timeline();
        const scatter = <ScatterSymbol>popAndMoveData.symbolData.positionable;
        tl.add(scatter.getFsReTrigger());
        tl.add(() => {
            scatter.destroy();
        })
        tl.add(popAndMoveData.moveAnimation, 0);

        return tl;
    }
}